import {
  addBackLink,
  addTitleRow,
  applyColumnLayout,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_FONT_12,
  hideColumnsAfter,
  hideRowsThrough,
  setCell,
  setValueDataRow,
  setupSheetView,
  SUBTITLE_FONT,
  THIN,
  THIN_BLACK,
} from "./detailSheetCommon";

const COL_START = 4;
const COL_END = 9;

const SUBTITLE_ROW = 9;
const HEADER_ROW = 10;
const TEMPLATE_ROW = 11;
const SPACER_ROW = 12;
const DATA_START_ROW = 13;

const SUBTITLE_TEXT =
  "Please indicate material responsible business conduct and sustainability issues pertaining to environmental and social matters that present a risk or an opportunity to your business, rationale for identifying the same, approach to adapt or mitigate the risk along-with its financial implications, as per the following format";

function borderConductHeaderRow(ws, row) {
  for (let col = COL_START; col <= COL_END; col += 1) {
    ws.getCell(row, col).border = THIN_BLACK;
  }
}

export function buildBusinessConductIssuesSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Business conduct issues");
  applyColumnLayout(
    ws,
    {
      A: 9.1796875,
      B: 9.1796875,
      C: 9.1796875,
      D: 6.7265625,
      E: 30.453125,
      F: 30.453125,
      G: 30.453125,
      H: 30.453125,
      I: 35.7265625,
      J: 9.1796875,
      K: 9.1796875,
      L: 9.1796875,
    },
    ["A", "B"]
  );
  hideColumnsAfter(ws, 12);
  setupSheetView(ws, { xSplit: 3, ySplit: 12, topLeftCell: "D13", zoomScale: 80 });
  hideRowsThrough(ws, 5);

  addBackLink(ws, COL_END);
  addTitleRow(
    ws,
    COL_START,
    COL_END,
    "Overview of the entity's material responsible business conduct issues"
  );

  ws.mergeCells(SUBTITLE_ROW, COL_START, SUBTITLE_ROW, COL_END);
  const subtitleCell = ws.getCell(SUBTITLE_ROW, COL_START);
  subtitleCell.value = SUBTITLE_TEXT;
  subtitleCell.font = SUBTITLE_FONT;
  subtitleCell.border = THIN_BLACK;
  subtitleCell.alignment = { horizontal: "left", vertical: "middle", wrapText: true, align: "center" };
  ws.getRow(SUBTITLE_ROW).height = 35.15;

  borderConductHeaderRow(ws, HEADER_ROW);
  ws.getRow(HEADER_ROW).height = 50.15;
  [
    { col: COL_START, label: "Sr. No.", font: HEADER_FONT_12 },
    { col: 5, label: "Material issue identified", font: HEADER_FONT_12 },
    { col: 6, label: "Indicate whether risk or opportunity (R/O)", font: HEADER_FONT_12 },
    { col: 7, label: "Rationale for identifying the risk / opportunity", font: HEADER_FONT_11 },
    { col: 8, label: "In case of risk, approach to adapt or mitigate", font: HEADER_FONT_11 },
    {
      col: COL_END,
      label:
        "Financial implications of the risk or opportunity (Indicate positive or negative implications)",
      font: HEADER_FONT_11,
    },
  ].forEach(({ col, label, font }) => {
    setCell(ws, HEADER_ROW, col, label, { font, bordered: false });
  });

  borderConductHeaderRow(ws, TEMPLATE_ROW);
  for (let col = COL_START; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false });
  }
  ws.getRow(TEMPLATE_ROW).height = 31;
  ws.getRow(TEMPLATE_ROW).hidden = true;

  ws.mergeCells(SPACER_ROW, COL_START, SPACER_ROW, COL_END);
  ws.getCell(SPACER_ROW, COL_START).border = { top: THIN, left: THIN, bottom: THIN, right: THIN };
  ws.getRow(SPACER_ROW).height = 30;

  const issues = sectionA?.transparencyAndDisclosures?.materialIssues || [];
  const rows = issues.length ? issues : [];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setValueDataRow(ws, row, COL_START, COL_END, item, [
      { col: COL_START, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: 5, value: item?.issueIdentify ?? "", align: "left" },
      { col: 6, value: item?.riskOrOpportunity ?? "", align: "center" },
      { col: 7, value: item?.rationale ?? "", align: "left" },
      { col: 8, value: item?.mitigationApproach ?? "", align: "left" },
      { col: COL_END, value: item?.financialImplications ?? "", align: "left" },
    ]);
    ws.getRow(row).height = idx === 0 ? 43.5 : 29;
  });

  hideRowsThrough(ws, 5);
  return ws;
}
